// icons/trauma.svg

export const TraumaIconV2 = (props) => (
  <svg
    className={props.className}
    width="18"
    height="32"
    viewBox="0 0 18 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.25" y="0.25" width="17.5" height="3.5" fill="#34363E" />
    <rect x="5.5" y="28.25" width="7" height="3.5" fill="#34363E" />
    <rect x="5.5" y="9" width="7" height="3.5" fill="#34363E" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 15.5153V3.75H2V16.4847L7.25 25.2347V29.125H10.75V25.2347L16 16.4847V3.75H12.5V15.5153L9 21.3486L5.5 15.5153Z"
      fill="#34363E"
    />
  </svg>
);
